"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCase = void 0;
var titleCase = exports.titleCase = function titleCase(str) {
  if (str === "" || str == null) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};